import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  NgZone,
  ViewChild,
} from '@angular/core';
import { TabViewModule } from 'primeng/tabview';
import { Calendar, CalendarModule } from 'primeng/calendar';
import { es } from 'date-fns/locale';
import { DateFnsModule } from 'ngx-date-fns';
import {
  addHours,
  set,
  format,
  parse,
  addDays,
  subDays,
  addMonths,
  subMonths,
  isPast,
  isEqual,
} from 'date-fns';
import { ApiService } from '@shared/services/api.service';
import { DateHoursTable } from '@shared/interfaces/date-hours-table';
import { SelectedItems } from '@shared/interfaces/selected-items';
import { Subject, debounceTime } from 'rxjs';
import { DateDaysTable } from '@shared/interfaces/date-days-table';
import { IListViewsPlanning } from '@shared/interfaces/list-views-planning';
declare var google: any;

@Component({
  selector: 'app-planning-new',
  templateUrl: './planning-new.component.html',
  styleUrls: ['./planning-new.component.scss'],
})
export class PlanningNewComponent {
  @ViewChild('calendarMain') calendarMain!: ElementRef;
  @ViewChild('btnOpenCalendar') btnOpenCalendar!: ElementRef;
  @ViewChild('filterSelectServices') filterSelectServices!: ElementRef;
  @ViewChild('calendar') calendar!: Calendar;

  date: Date | undefined;
  Object = Object;
  viewTab: IListViewsPlanning = {
    hours: false,
    days: false,
    months: true,
  };
  dateHoursTable!: DateHoursTable[] | null;
  dateHoursTableFiltered: any[] = [];
  dateDaysTable!: DateDaysTable[];
  dateDaysTableFiltered: any[] = [];
  dateHourTable!: any | null;

  showCalendar: boolean = false;
  CBBookingService: any[] = [];
  checkboxState: { [key: string]: boolean } = {};

  listCodItems: any = [];
  allItemsSchedule: any[] = [];
  selectedItems: any = [];

  AllDataBSCB: any[] = [];
  activeIndex: number = 0;
  tabs: string[] = ['bookedToday', 'planning'];
  showBtnCalendar: boolean = false;

  showZoom: any = {
    '08:00': false,
    '09:00': false,
    '10:00': false,
    '11:00': false,
    '12:00': false,
    '13:00': false,
    '14:00': false,
    '15:00': false,
    '16:00': false,
    '17:00': false,
    '18:00': false,
    '19:00': false,
    '20:00': false,
    '21:00': false,
    '22:00': false,
  };

  showZoomDay: any = {};

  servicesToday: any[] = [];
  showBsToday: boolean = false;
  showBookingByHour: boolean = false;
  showBookingByDateService: boolean = false;
  seeSchedule: boolean = false;
  headerBsTodayDialog: string = '';
  headerBookingsByHourDialog: string = '';
  headerBookingsByDateServiceDialog: string = '';
  bookingIdToEdit: number = 0;
  serviceSelected: any = null;
  selectedMonthString: string = '';
  selectedDayString: string = '';
  selectedHourString: string = '';
  allBookings: any[] = [];
  selectedBookings: any[] = [];
  enableBtnGenerateAmount: boolean = false;
  listDatesUnavailables: any = [];
  canChangeStatusService: boolean = true;
  pickerDate: Date | undefined;
  minHour!: Date;
  maxHour!: Date;

  dataFilterPlaning: any = [];
  todayDateString: string = '';

  private clickAddToDate = new Subject();
  private clickSubToDate = new Subject();

  constructor(
    private el: ElementRef,
    public apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    let roles = JSON.parse(localStorage.getItem('me') ?? '')?.roles;

    if (roles) {
      if (
        roles.includes('super-admin') ||
        roles.includes('admin') ||
        roles.includes('manage')
      ) {
        this.canChangeStatusService = true;
      } else {
        this.canChangeStatusService = false;
      }
    } else {
      this.canChangeStatusService = false;
    }

    this.pickerDate = new Date();

    this.minHour = new Date();
    this.minHour.setHours(8);
    this.maxHour = new Date();
    this.maxHour.setHours(22);

    this.clickAddToDate.pipe(debounceTime(500)).subscribe(() => {
      this.addDate();
    });
    this.clickSubToDate.pipe(debounceTime(500)).subscribe(() => {
      this.subtractDate();
    });

    this.selectedMonthString = format(new Date(), 'MM-yyyy', { locale: es });
    this.todayDateString = format(new Date(), 'dd-MM-yyyy', { locale: es });
    console.log(this.todayDateString);

    this.selectedDayString = '';
    this.selectedHourString = '';

    this.apiService
      .getBookingServicesByMonth(this.selectedMonthString)
      .subscribe((response: any) => {
        console.log(response);
        this.dateDaysTable = response.schedule;
        console.log('daystable', this.dateDaysTable);
        this.dateDaysTableFiltered = JSON.parse(
          JSON.stringify(this.dateDaysTable)
        );
        this.allItemsSchedule = response.items;

        this.removeAllItemsToTable();
        // this.selectAllServicesCB();
      });

    this.apiService
      .get('/service/get-by-planning')
      .subscribe((response: any) => {
        this.dataFilterPlaning = response;
      });

    this.apiService
      .get('/service/get-dates-unavailables')
      .subscribe((response: any) => {
        this.listDatesUnavailables = response;
      });

    setInterval(() => {
      if (this.viewTab['months']) {
        this.getBookingServicesByMonth();
      } else if (this.viewTab['days']) {
        this.getBookingServicesByDay();
      }
      this.cdr.detectChanges();
    }, 60000);

    this.cdr.detectChanges();
  }

  validateDateStatus(hour: string, service: any) {
    let fullDate = this.getFullDate(hour);

    let existDateService = this.listDatesUnavailables.find((date: any) => {
      return date.date_time == fullDate && date.service == service;
    });

    if (existDateService) {
      return true;
    } else {
      return false;
    }
  }

  addDateToBlock(hour: string, service: any) {
    let fullDate = this.getFullDate(hour);

    this.apiService
      .post('/service/set-date-unavailable', {
        date_time: fullDate,
        service: service,
      })
      .subscribe((response: any) => {
        this.listDatesUnavailables.push(response);
      });
  }

  deleteDateFromBlock(hour: string, service: any) {
    let fullDate = this.getFullDate(hour);

    let dateToDelete = this.listDatesUnavailables.find(
      (date: any) => date.date_time == fullDate && date.service == service
    );

    this.apiService
      .get(`/service/delete-date-unavailable/${dateToDelete.id}`)
      .subscribe((response: any) => {
        this.listDatesUnavailables = this.listDatesUnavailables.filter(
          (date: any) => date.id != dateToDelete.id
        );
      });
  }

  getFullDate(hour: string) {
    let selectedDayDate = parse(
      this.selectedDayString,
      'dd-MM-yyyy',
      new Date(),
      {
        locale: es,
      }
    );
    let selectedDayAux = format(selectedDayDate, 'yyyy-MM-dd', { locale: es });

    let selectedHourDate = parse(hour, 'HH:mm', new Date(), {
      locale: es,
    });

    let selectedHourAux = format(selectedHourDate, 'HH:mm:ss', { locale: es });
    return `${selectedDayAux} ${selectedHourAux}`;
  }

  filterTable(event: any) {

    console.log('event: ', event);
    
    let value = event.target?.value ?? event;

    let allDataTable: any = [];
    if (this.viewTab['months']) {
      allDataTable = JSON.parse(JSON.stringify(this.dateDaysTable));
    } else if (this.viewTab['days']) {
      allDataTable = JSON.parse(JSON.stringify(this.dateHoursTable));
    }

    if (value === 'all') {
      if (this.viewTab['months']) {
        this.dateDaysTableFiltered = allDataTable;
      } else if (this.viewTab['days']) {
        this.dateHoursTableFiltered = allDataTable;
      }
      this.selectAllServicesCB();
      return;
    }

    if (this.viewTab['months']) {
      const dateDaysTableAux = allDataTable;

      this.dateDaysTableFiltered = dateDaysTableAux
        .map((date: any) => {
          const itemDate = { ...date };
          const keys = Object.keys(itemDate.data);
          keys.forEach((key: string) => {
            if (key !== value) {
              delete itemDate.data[key];
            }
          });
          return itemDate;
        })
        .filter((item: any) => item !== undefined);
    } else if (this.viewTab['days']) {
      const dateHoursTableAux = allDataTable;

      this.dateHoursTableFiltered = dateHoursTableAux
        .map((date: any) => {
          const itemDate = { ...date };
          const keys = Object.keys(itemDate.data);
          keys.forEach((key: string) => {
            if (key !== value) {
              delete itemDate.data[key];
            }
          });
          return itemDate;
        })
        .filter((item: any) => item !== undefined);
    }

    this.selectAllServicesCB();

  }

  getTodayDate() {
    if (this.viewTab['months']) {
      this.selectedDayString = format(new Date(), 'dd-MM-yyyy', { locale: es });
      this.selectedMonthString = format(new Date(), 'MM-yyyy', { locale: es });
      this.getBookingServicesByMonth();
    } else if (this.viewTab['days']) {
      this.selectedDayString = format(new Date(), 'dd-MM-yyyy', { locale: es });
      this.selectedMonthString = format(new Date(), 'MM-yyyy', { locale: es });
      this.getBookingServicesByDay();
    }
  }

  onAddToDate() {
    if (this.viewTab['months']) {
      let date = parse(this.selectedMonthString, 'MM-yyyy', new Date(), {
        locale: es,
      });

      date = addMonths(date, 1);
      this.selectedMonthString = format(date, 'MM-yyyy', { locale: es });
      this.selectedDayString = format(date, 'dd-MM-yyyy', { locale: es });
      this.clickAddToDate.next(null);
    } else if (this.viewTab['days']) {
      let date = parse(this.selectedDayString, 'dd-MM-yyyy', new Date(), {
        locale: es,
      });

      date = addDays(date, 1);
      this.selectedDayString = format(date, 'dd-MM-yyyy', { locale: es });
      this.selectedMonthString = format(date, 'MM-yyyy', { locale: es });
      this.clickAddToDate.next(null);
    }
  }

  addDate() {
    if (this.viewTab['months']) {
      this.getBookingServicesByMonth();
    } else if (this.viewTab['days']) {
      this.getBookingServicesByDay();
    }
  }

  onSubtractToDate() {
    if (this.viewTab['months']) {
      let date = parse(this.selectedMonthString, 'MM-yyyy', new Date(), {
        locale: es,
      });
      date = subMonths(date, 1);
      this.selectedMonthString = format(date, 'MM-yyyy', { locale: es });
      this.selectedDayString = format(date, 'dd-MM-yyyy', { locale: es });
      this.clickSubToDate.next(null);
    } else if (this.viewTab['days']) {
      let date = parse(this.selectedDayString, 'dd-MM-yyyy', new Date(), {
        locale: es,
      });

      date = subDays(date, 1);
      this.selectedDayString = format(date, 'dd-MM-yyyy', { locale: es });
      this.selectedMonthString = format(date, 'MM-yyyy', { locale: es });
      this.clickSubToDate.next(null);
    }
  }

  subtractDate() {
    if (this.viewTab['months']) {
      this.getBookingServicesByMonth();
    } else if (this.viewTab['days']) {
      this.getBookingServicesByDay();
    }
  }

  getBookingServicesByMonth() {
    this.dateDaysTable = [];
    this.ngZone.run(() => {
      this.apiService
        .getBookingServicesByMonth(this.selectedMonthString)
        .subscribe((response: any) => {
          this.dateDaysTable = response.schedule;
          this.allItemsSchedule = response.items;
          console.log('allitems', this.allItemsSchedule);

          this.dateDaysTableFiltered = JSON.parse(
            JSON.stringify(this.dateDaysTable)
          );
          this.filterTable(this.filterSelectServices.nativeElement.value);
          this.removeAllItemsToTable();

          // this.selectAllServicesCB();
        });
    });
  }

  getBookingServicesByDay() {
    this.dateHoursTable = [];
    this.ngZone.run(() => {
      this.apiService
        .getBookingServicesByDay(this.selectedDayString)
        .subscribe((response: any) => {
          this.dateHoursTable = response.schedule;
          this.allItemsSchedule = response.items;
          this.dateHoursTableFiltered = JSON.parse(
            JSON.stringify(this.dateHoursTable)
          );
          console.log(
            'this.dateHoursTableFiltered',
            this.dateHoursTableFiltered
          );
          this.filterTable(this.filterSelectServices.nativeElement.value);
          // this.removeAllItemsToTable();

          // this.selectAllServicesCB();
        });
    });
  }

  getBookingServicesByHour() {
    // this.dateHourTable = [];
    // this.ngZone.run(() => {
    //   this.apiService.getBookingServicesByHour(this.selectedHourString).subscribe(
    //     (response: any) => {
    //       console.log('response', response);
    //       this.dateHourTable = response.schedule;
    //       this.allItemsSchedule = response.items;
    //       // this.selectAllServicesCB();
    //     }
    //   );
    // });
  }

  selectAllServicesCB() {
    this.selectedItems = [];
    this.AllDataBSCB = [];
    this.CBBookingService = [];
    this.selectedBookings = [];
    this.removeAllItemsToTable();

    if (this.viewTab['months']) {
      this.AllDataBSCB = [];
      // for(let dayData of this.dateDaysTableFiltered ?? []){
      //   for(let service in dayData.data){

      //       this.AllDataBSCB.push(dayData.date+'---/---'+service);
      //       this.toggleOptionCB(dayData.date+'---/---'+service);

      //   }

      // }
    } else if (this.viewTab['days']) {
      this.AllDataBSCB = [];
      for (let hourData of this.dateHoursTableFiltered ?? []) {
        for (let service in hourData.data) {
          this.AllDataBSCB.push(hourData.hour + '---/---' + service);
          this.toggleOptionCB(hourData.hour + '---/---' + service);
        }
      }
    }
  }

  manageCalendar(event: any) {
    event.preventDefault();
    // this.calendarMain.nativeElement.showPicker();
    this.showCalendar = !this.showCalendar;

    if (this.showCalendar) {
      setTimeout(() => {
        this.calendar.showOverlay();
      }, 0);
    } else {
      setTimeout(() => {
        this.calendar.hideOverlay();
      }, 0);
    }
  }

  selectDateOnCalendar(event: any) {
    if (this.viewTab['months']) {
      this.selectedMonthString = format(event, 'MM-yyyy', { locale: es });
      this.selectedDayString = format(event, 'dd-MM-yyyy', { locale: es });

      this.getBookingServicesByMonth();

      this.showCalendar = false;
    } else if (this.viewTab['days']) {
      this.selectedDayString = format(event, 'dd-MM-yyyy', { locale: es });
      this.selectedMonthString = format(event, 'MM-yyyy', { locale: es });
      this.getBookingServicesByDay();
    }
  }

  toggleOptionCB(option: string) {
    this.selectedItems = [];

    if (this.checkboxState[option]) {
      return;
    }

    let optionArray: string[] = option.split('---/---');
    let date: string = optionArray[0];
    let service: string = optionArray[1];

    if (this.CBBookingService.includes(option)) {
      this.CBBookingService = this.CBBookingService.filter((o) => o !== option);
      if (this.allItemsSchedule.length > 0) {
        this.removeItemsToTable(date, service);
      }
    } else {
      this.CBBookingService.push(option);
      if (this.allItemsSchedule.length > 0) {
        this.addItemsToTable(date, service);
      }
    }

    this.cdr.detectChanges();
  }

  addItemsToTable(date: string, service: string) {
    this.toggleItems(date, service, true);
    this.fillItemsTable();
  }

  removeItemsToTable(date: string, service: string) {
    this.toggleItems(date, service, false);
    this.fillItemsTable();
  }

  removeAllItemsToTable() {
    this.selectedItems = [];
    this.AllDataBSCB = [];
    this.CBBookingService = [];
    this.selectedBookings = [];

    this.allItemsSchedule = this.allItemsSchedule.map((item: any) => {
      item.include = false;
      return item;
    });
  }

  toggleItems(date: string, service: string, toggleBoolean: boolean) {
    this.listCodItems = [];
    let dateType: string = '';
    if (this.viewTab['months']) {
      if (this.dateDaysTable && this.dateDaysTableFiltered?.length > 0) {
        let dataDays: any = this.dateDaysTableFiltered?.filter((day: any) => {
          return day.date == date;
        });
        // item_group_booking_service_id
        for (let dataDay of dataDays) {
          if (dataDay['date'] == date) {
            for (let planning_group_name in dataDay['data']) {
              if (planning_group_name == service) {
                for (let service in dataDay['data'][planning_group_name]) {
                  for (let bs of dataDay['data'][planning_group_name][
                    service
                  ]) {
                    if (
                      !this.listCodItems.includes(
                        bs.item_group_booking_service_id
                      ) &&
                      bs.item_group_booking_service_id != null
                    ) {
                      this.listCodItems.push(bs.item_group_booking_service_id);
                    }
                  }
                }
              }
            }
          }
        }

        this.allItemsSchedule = this.allItemsSchedule.map((item: any) => {
          if (this.listCodItems.includes(item.cod_team)) {
            item.include = toggleBoolean;
          }
          return item;
        });
      }
    } else if (this.viewTab['days']) {
      if (this.dateHoursTable && this.dateHoursTableFiltered?.length > 0) {
        let dataHours: any = this.dateHoursTableFiltered?.filter((day: any) => {
          return day.hour == date;
        });
        // item_group_booking_service_id

        for (let dataHour of dataHours) {
          if (dataHour['hour'] == date) {
            for (let planning_group_name in dataHour['data']) {
              if (planning_group_name == service) {
                for (let service in dataHour['data'][planning_group_name]) {
                  for (let bs of dataHour['data'][planning_group_name][
                    service
                  ]) {
                    if (
                      !this.listCodItems.includes(
                        bs.item_group_booking_service_id
                      ) &&
                      bs.item_group_booking_service_id != null
                    ) {
                      this.listCodItems.push(bs.item_group_booking_service_id);
                    }
                  }
                }
              }
            }
          }
        }

        console.log('allitems', this.allItemsSchedule);
        this.allItemsSchedule = this.allItemsSchedule.map((item: any) => {
          if (this.listCodItems.includes(item.cod_team)) {
            item.include = toggleBoolean;
          }
          return item;
        });
      }
    }
  }

  fillItemsTable() {
    this.selectedItems = [];

    this.allItemsSchedule.forEach((item: any) => {
      if (item.include) {
        for (let itemAux of item.items) {
          let existItem = this.selectedItems.find(
            (itemFind: any) => itemFind.id == itemAux.id
          );
          if (existItem) {
            let selectedItemsClone = JSON.parse(
              JSON.stringify(this.selectedItems)
            );
            this.selectedItems = selectedItemsClone.map((itemMap: any) => {
              if (itemMap.id == existItem.id) {
                const itemClonado = JSON.parse(JSON.stringify(itemMap));
                itemClonado.units += itemAux.units;
                return itemClonado;
              }
              return itemMap;
            });
          } else {
            this.selectedItems.push(itemAux);
          }
        }
      }
    });
  }

  onChangeTab(event: any) {
    if (this.tabs[this.activeIndex] == 'planning') {
      this.showBtnCalendar = true;
    } else {
      this.showBtnCalendar = false;
    }
  }

  handleChangeView(event: any, viewType: string, date: string = 'none') {
    if (viewType in this.viewTab) {
      this.changeView(viewType);

      if (viewType == 'months') {
        if (date != 'none') {
          this.selectedMonthString = date;
        }
        this.getBookingServicesByMonth();
      } else if (viewType == 'days') {
        if (date != 'none') {
          this.selectedDayString = date;
        }
        this.getBookingServicesByDay();
      } else if (viewType == 'hours') {
        // if(this.pickerDate){

        //   const [hour, minute] = date.split(':').map(Number);

        //   this.pickerDate?.setHours(hour, minute);
        // }

        if (date != 'none') {
          this.selectedHourString = date;
        }

        if (this.dateHoursTable) {
          this.selectedBookings = [];
          let dateData: any = this.dateHoursTableFiltered.filter(
            (dayAux: any) => dayAux.hour == date
          )[0];

          if (dateData) {
            for (let planning_group_name in dateData['data']) {
              for (let service in dateData['data'][planning_group_name]) {
                for (let bs of dateData['data'][planning_group_name][service]) {
                  if ('all_bookings' in bs) {
                    for (let booking of bs.all_bookings) {
                      if (!this.selectedBookings.includes(booking)) {
                        this.selectedBookings.push(booking);
                      }
                    }
                  }
                }
              }
            }
          }
        }

        this.selectedBookings.sort((a, b) => {
          if (a.customer.name < b.customer.name) {
            return -1;
          }
          if (a.customer.name > b.customer.name) {
            return 1;
          }
          return 0;
        });

        console.log('this.selectedBookings', this.selectedBookings);

      }
    }
  }

  returnItemsByBooking(booking: any) {
    let htmlToRender = '';

    booking.items.forEach((item: any) => {
      htmlToRender += `<span class="inline-block bg-green-500 text-white py-1 px-2 rounded-full mr-1 mt-1 text-nowrap">${item.item.name}&nbsp;&nbsp;${item.units}</span>`;
    });

    return htmlToRender;
  }

  returnAddressFromBooking(booking: any) {
    let htmlToRender = '';

    booking.addresses.forEach((address: any, index: number) => {
      if (index == 0) htmlToRender += "<p class='font-bold'>Direcciones:</p>";
      htmlToRender += `<p class="">${address}</p>`;
    });

    return htmlToRender;
  }

  changeView(viewTabName: string) {
    this.viewTab['months'] = false;
    this.viewTab['days'] = false;
    this.viewTab['hours'] = false;

    if (viewTabName in this.viewTab) {
      if (viewTabName == 'months') {
        this.viewTab['months'] = true;
      } else if (viewTabName == 'days') {
        this.viewTab['days'] = true;
      } else if (viewTabName == 'hours') {
        this.viewTab['hours'] = true;
      }
    }
  }

  showBsTodayDialog(serviceId: number) {
    this.showBsToday = true;
    this.serviceSelected = this.servicesToday.filter(
      (service: any) => service.service_id == serviceId
    )[0];
    this.headerBsTodayDialog = `Servicios de reservas de: ${this.serviceSelected.service_name}`;
  }
  openBookingByHourDialog(bookingId: number, bookingReference: string) {
    this.bookingIdToEdit = bookingId;
    console.log(this.allBookings, 'this.allBookings');
    let bookingAux: any = this.selectedBookings.filter(
      (booking: any) => booking.id == bookingId
    )[0];
    if (bookingAux.status_id == 4) {
      this.enableBtnGenerateAmount = false;
    } else {
      this.enableBtnGenerateAmount = true;
    }
    this.headerBookingsByHourDialog = 'Reserva: ' + bookingReference;
    this.showBookingByHour = true;
  }

  openBookingByDateServiceDialog(date: string, service_group: any) {
    this.selectedBookings = [];
    if (this.viewTab['months']) {
      if (this.dateDaysTable) {
        let dateData: any = this.dateDaysTable.filter(
          (dayAux: any) => dayAux.date == date
        )[0];

        if (dateData) {
          for (let planning_group_name in dateData['data']) {
            if (planning_group_name == service_group) {
              for (let service in dateData['data'][planning_group_name]) {
                for (let bs of dateData['data'][planning_group_name][service]) {
                  if ('all_bookings' in bs) {
                    this.selectedBookings = bs.all_bookings;
                  }
                }
              }
            }
          }
        }
      }
    } else if (this.viewTab['days']) {
      if (this.dateHoursTableFiltered) {
        let dateData: any = this.dateHoursTableFiltered.filter(
          (dayAux: any) => dayAux.hour == date
        )[0];

        if (dateData) {
          for (let planning_group_name in dateData['data']) {
            if (planning_group_name == service_group) {
              for (let service in dateData['data'][planning_group_name]) {
                for (let bs of dateData['data'][planning_group_name][service]) {
                  if ('all_bookings' in bs) {
                    this.selectedBookings = bs.all_bookings;
                  }
                }
              }
            }
          }
        }
      }
    }

    if (this.selectedBookings.length > 0) {
      this.selectedBookings.sort((a, b) => {
        if (a.customer.name < b.customer.name) {
          return -1;
        }
        if (a.customer.name > b.customer.name) {
          return 1;
        }
        return 0;
      });
    }

    this.headerBookingsByDateServiceDialog = 'Reservas asociadas';
    this.showBookingByDateService = true;

  }

  validateTrueFromShowZoom(): boolean {
    for (let hour in this.showZoom) {
      if (this.showZoom[hour] == true) {
        return true;
      }
    }
    return false;
  }

  countBookingServicesUnits(dateOrHour: any, planninGroupName: any) {
    let counter: number = 0;
    if (this.viewTab['days']) {
      if (this.dateHoursTableFiltered) {
        let dateData: any = this.dateHoursTableFiltered.filter(
          (dayAux: any) => dayAux.hour == dateOrHour
        )[0];

        if (dateData) {
          for (let planning_group_name in dateData['data']) {
            if (planninGroupName == planning_group_name) {
              for (let service in dateData['data'][planning_group_name]) {
                for (let bookingService of dateData['data'][
                  planning_group_name
                ][service]) {
                  if ('all_bookings' in bookingService) {
                  } else {
                    if (bookingService.is_countable) {
                      counter += bookingService.units;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else if (this.viewTab['months']) {
      if (this.dateDaysTableFiltered) {
        let dateData: any = this.dateDaysTableFiltered.filter(
          (dayAux: any) => dayAux.date == dateOrHour
        )[0];

        if (dateData) {
          for (let planning_group_name in dateData['data']) {
            if (planninGroupName == planning_group_name) {
              for (let service in dateData['data'][planning_group_name]) {
                for (let bookingService of dateData['data'][
                  planning_group_name
                ][service]) {
                  if ('all_bookings' in bookingService) {
                  } else {
                    if (bookingService.is_countable) {
                      counter += bookingService.units;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return counter;
  }

  getStatusString(data: any) {
    if (data) {
      return data[0].status;
    }
    return '';
  }
  getStatusColor(data: any): string {
    if (data) {
      let status_color = data[0].status_color;
      return status_color;
    }
    return '';
  }
  setShowZoomFalse(event?: any) {
    for (let hour in this.showZoom) {
      this.showZoom[hour] = false;
    }
  }
  setShowZoomHourToTrue(event: any, dataHour: string) {
    this.showZoom[dataHour] = true;
    this.getBookingFromHour(dataHour);
  }

  serviceProfileQuantityList(dateTime: string, planingGroupName: any) {
    let htmlToPrint = '';

    if (this.viewTab['months']) {
      if (this.dateDaysTableFiltered) {
        let dateData: any = this.dateDaysTableFiltered.filter(
          (dayAux: any) => dayAux.date == dateTime
        )[0];

        let listServiceProfiles: any = [];

        if (dateData) {
          for (let planningGroupNameData in dateData['data']) {
            if (planningGroupNameData == planingGroupName) {
              for (let service in dateData['data'][planningGroupNameData]) {
                for (let bs of dateData['data'][planningGroupNameData][
                  service
                ]) {
                  if ('all_bookings' in bs) {
                  } else {
                    if (bs.is_countable && bs.is_group == 0) {
                      let existSP = listServiceProfiles.findIndex(
                        (sp: any) => sp.name == bs.name
                      );
                      if (existSP === -1) {
                        let newSP = {
                          name: '',
                          counter: 0,
                        };

                        newSP.name = bs.name;
                        newSP.counter += bs.units;
                        listServiceProfiles.push(newSP);
                      } else {
                        listServiceProfiles[existSP].counter += bs.units;
                      }
                    }
                  }
                }
              }
            }
          }

          for (let serviceProfile of listServiceProfiles) {
            htmlToPrint += `<p class="font-normal">${serviceProfile.name} x${serviceProfile.counter}</p>`;
          }
        }
      }
    } else if (this.viewTab['days']) {
      if (this.dateHoursTable) {
        let dateData: any = this.dateHoursTable.filter(
          (dayAux: any) => dayAux.hour == dateTime
        )[0];

        let listServiceProfiles: any = [];

        if (dateData) {
          for (let planningGroupNameData in dateData['data']) {
            if (planningGroupNameData == planingGroupName) {
              for (let service in dateData['data'][planningGroupNameData]) {
                for (let bs of dateData['data'][planningGroupNameData][
                  service
                ]) {
                  if ('all_bookings' in bs) {
                  } else {
                    if (bs.is_countable && bs.is_group == 0) {
                      let existSP = listServiceProfiles.findIndex(
                        (sp: any) => sp.name == bs.name
                      );
                      if (existSP === -1) {
                        let newSP = {
                          name: '',
                          counter: 0,
                        };

                        newSP.name = bs.name;
                        newSP.counter += bs.units;
                        listServiceProfiles.push(newSP);
                      } else {
                        listServiceProfiles[existSP].counter += bs.units;
                      }
                    }
                  }
                }
              }
            }
          }

          for (let serviceProfile of listServiceProfiles) {
            htmlToPrint += `<p class="font-normal">${serviceProfile.name} x${serviceProfile.counter}</p>`;
          }
        }
      }
    }

    return `${htmlToPrint}`;
  }

  customersGroupQuantityList(dateTime: string, planingGroupName: any) {
    let htmlToPrint = '';

    if (this.viewTab['months']) {
      if (this.dateDaysTable) {
        let dateData: any = this.dateDaysTable.filter(
          (dayAux: any) => dayAux.date == dateTime
        )[0];

        let listCustomers: any = [];
        let listServiceProfiles: any = [];

        if (dateData) {
          for (let planningGroupNameData in dateData['data']) {
            if (planningGroupNameData == planingGroupName) {
              for (let service in dateData['data'][planningGroupNameData]) {
                for (let bs of dateData['data'][planningGroupNameData][
                  service
                ]) {
                  if ('all_bookings' in bs) {
                    for (let booking of bs.all_bookings) {
                      if (booking.is_group) {
                        let indexClient = listCustomers.findIndex(
                          (client: any) => client.id == booking.customer_id
                        );
                        if (indexClient === -1) {
                          let newClient = {
                            customer_id: 0,
                            name: '',
                            allServicesProfiles: [],
                          };

                          newClient.customer_id = booking.customer_id;
                          newClient.name = booking.customer.name;
                          listCustomers.push(newClient);
                        }
                      }
                    }
                  }
                }
                for (let customer of listCustomers) {
                  listServiceProfiles = [];
                  for (let bs of dateData['data'][planningGroupNameData][
                    service
                  ]) {
                    if ('all_bookings' in bs) {
                    } else {
                      if (bs.is_countable) {
                        if (bs.customer_id == customer.customer_id) {
                          let existSP = listServiceProfiles.findIndex(
                            (sp: any) => sp.name == bs.name
                          );
                          if (existSP === -1) {
                            let newSP: any = {
                              name: '',
                              counter: 0,
                            };

                            newSP.name = bs.name;
                            newSP.counter += bs.units;
                            listServiceProfiles.push(newSP);
                          } else {
                            listServiceProfiles[existSP].counter += bs.units;
                          }
                        }
                      }
                    }
                  }
                  customer.allServicesProfiles = listServiceProfiles;
                }
              }
            }
          }

          for (let customer of listCustomers) {
            htmlToPrint += `<p class="font-normal text-[12px]  ">${customer.name}`;

            htmlToPrint += `</p>`;
            htmlToPrint += `<p class="font-normal border-b border-[silver]">`;
            for (let serviceProfile of customer.allServicesProfiles) {
              htmlToPrint += `${serviceProfile.name} x${serviceProfile.counter}   `;
            }

            htmlToPrint += `</p>`;
          }
        }
      }
    } else if (this.viewTab['days']) {
      if (this.dateHoursTable) {
        let dateData: any = this.dateHoursTable.filter(
          (dayAux: any) => dayAux.hour == dateTime
        )[0];

        let listCustomers: any = [];
        let listServiceProfiles: any = [];

        if (dateData) {
          for (let planningGroupNameData in dateData['data']) {
            if (planningGroupNameData == planingGroupName) {
              for (let service in dateData['data'][planningGroupNameData]) {
                for (let bs of dateData['data'][planningGroupNameData][
                  service
                ]) {
                  if ('all_bookings' in bs) {
                    for (let booking of bs.all_bookings) {
                      if (booking.is_group) {
                        let indexClient = listCustomers.findIndex(
                          (client: any) => client.id == booking.customer_id
                        );
                        if (indexClient === -1) {
                          let newClient = {
                            customer_id: 0,
                            name: '',
                            allServicesProfiles: [],
                          };

                          newClient.customer_id = booking.customer_id;
                          newClient.name = booking.customer.name;
                          listCustomers.push(newClient);
                        }
                      }
                    }
                  }
                }
                for (let customer of listCustomers) {
                  listServiceProfiles = [];
                  for (let bs of dateData['data'][planningGroupNameData][
                    service
                  ]) {
                    if ('all_bookings' in bs) {
                    } else {
                      if (bs.is_countable) {
                        if (bs.customer_id == customer.customer_id) {
                          let existSP = listServiceProfiles.findIndex(
                            (sp: any) => sp.name == bs.name
                          );
                          if (existSP === -1) {
                            let newSP: any = {
                              name: '',
                              counter: 0,
                            };

                            newSP.name = bs.name;
                            newSP.counter += bs.units;
                            listServiceProfiles.push(newSP);
                          } else {
                            listServiceProfiles[existSP].counter += bs.units;
                          }
                        }
                      }
                    }
                  }
                  customer.allServicesProfiles = listServiceProfiles;
                }
              }
            }
          }

          for (let customer of listCustomers) {
            htmlToPrint += `<p class="font-normal text-[12px] ">${customer.name}`;

            htmlToPrint += `</p>`;
            htmlToPrint += `<p class="font-normal border-b border-[silver]">`;
            for (let serviceProfile of customer.allServicesProfiles) {
              htmlToPrint += `${serviceProfile.name} x${serviceProfile.counter}   `;
            }

            htmlToPrint += `</p>`;
          }
        }
      }
    }

    return `${htmlToPrint}`;
  }

  collectionPointQuantityList(dateTime: string, planingGroupName: any){
    let addressesIncludedArray: string[] = []; 
    let htmlToRenderData: any[] = [];
    let htmlToRenderString: string = '';

    if (this.viewTab['months']) {
      if (this.dateDaysTable) {
        let dateData: any = this.dateDaysTable.filter(
          (dayAux: any) => dayAux.date == dateTime
        )[0];

        if (dateData) {
          for (let planning_group_name in dateData['data']) {
            if (planning_group_name == planingGroupName) {
              for (let service in dateData['data'][planning_group_name]) {
                for (let bs of dateData['data'][planning_group_name][service]) {
                  if ('all_bookings' in bs) {
                    bs.all_bookings?.forEach((booking: any, index: number) => {
                      booking.addresses?.forEach((address: any) => {
                        if(addressesIncludedArray.includes(address)){
                          let index: any = htmlToRenderData.findIndex((addressFilter: any) => addressFilter.address == address);
                          htmlToRenderData[index].count++;
                          
                        }else{

                          addressesIncludedArray.push(address);
                          htmlToRenderData.push({
                            address: address,
                            count: 1
                          });
                        }
                      });
                    });
                  }
                }
              }
            }
          }
        }
      }
    } else if (this.viewTab['days']) {
      if (this.dateHoursTableFiltered) {
        let dateData: any = this.dateHoursTableFiltered.filter(
          (dayAux: any) => dayAux.hour == dateTime
        )[0];

        if (dateData) {
          for (let planning_group_name in dateData['data']) {
            if (planning_group_name == planingGroupName) {
              for (let service in dateData['data'][planning_group_name]) {
                for (let bs of dateData['data'][planning_group_name][service]) {
                  if ('all_bookings' in bs) {
                    bs.all_bookings?.forEach((booking: any, index: number) => {
                      booking.addresses?.forEach((address: any) => {
                        if(addressesIncludedArray.includes(address)){
                          let index: any = htmlToRenderData.findIndex((addressFilter: any) => addressFilter.address == address);
                          htmlToRenderData[index].count++;
                          
                        }else{

                          addressesIncludedArray.push(address);
                          htmlToRenderData.push({
                            address: address,
                            count: 1
                          });
                        }
                      });
                    });
                  }
                }
              }
            }
          }
        }
      }
    }



    htmlToRenderData.forEach((addressHtml: any) => {
      htmlToRenderString += `<p class="">${addressHtml.address} x${addressHtml.count}</p>`;
    });

    return htmlToRenderString;


  }

  validateDayHasPassed(date: string): boolean {
    let DayDate = parse(date, 'dd-MM-yyyy', new Date(), {
      locale: es,
    });
    let todayDate = parse(this.todayDateString, 'dd-MM-yyyy', new Date(), {
      locale: es,
    });

    return isPast(DayDate) && !isEqual(DayDate, todayDate);
  }

  getUnitsFromBookingByHour(booking: any, selectedHourString: string) {
    let peopleCounter: number = 0;
    if (this.dateHoursTableFiltered) {
      let dateData: any = this.dateHoursTableFiltered.filter(
        (dayAux: any) => dayAux.hour == selectedHourString
      )[0];

      if (dateData) {
        for (let planning_group_name in dateData['data']) {
          for (let service in dateData['data'][planning_group_name]) {
            for (let bookingService of dateData['data'][planning_group_name][
              service
            ]) {
              if ('all_bookings' in bookingService) {
              } else {
                if (booking.id == bookingService.booking_id) {
                  peopleCounter += bookingService.units;
                }
              }
            }
          }
        }
      }
    }
    return peopleCounter;
  }

  getBookingFromHour(hour: string) {
    // this.selectedBookings = [];
    // if(this.dateHoursTable){
    //   for(let service in this.dateHoursTable[hour]){
    //     for(let bs of this.dateHoursTable[hour][service]){
    //       let existsBooking = this.selectedBookings.find((booking: any) => booking.id == bs['booking_id']);
    //       if(!existsBooking){
    //         this.allBookings.forEach((booking: any) => {
    //           if(booking.id == bs.booking_id){
    //             this.selectedBookings.push(booking);
    //           }
    //         });
    //       }
    //     }
    //   }
    // }
  }
}
